import * as React from 'react';
import {Button} from '@mui/material';
import Header from './header';
import img1 from '../asset/gestion_user.png';
import img2 from '../asset/calendrier.png';


export default function Dashboard(props) {

    return(
        <div style={{position:'absolute', right:0, left:0, top:0, bottom:0}}>
            <Header title='Tableau de bord'/>
            <div style={{display: 'flex', justifyContent:'center',  marginTop:'10%'}}>
                <Button variant='contained' style={{marginRight:60, display:'flex', flexDirection:'column'}} color='neutral' href='/gestion_employes'>
                <img
                    src={img1}
                    alt={'gestion des employés'}
                    style={{width:350}}
                    loading="lazy"
                />
                    <span style={{fontWeight:'bold'}}>Gestion des employés</span>
                </Button>
                <Button variant='contained' style={{marginRight:20, display:'flex', flexDirection:'column'}} color='neutral' href='/gestion_conges'>
                <img
                    src={img2}
                    alt={'gestion des congés'}
                    style={{width:350}}
                    loading="lazy"
                />
                    <span style={{fontWeight:'bold'}}>Gestion des Congés</span>
                </Button>
            </div>
        </div>
    )
}